import { Tab, Tabs } from '@mui/material';
import { Outlet, useLocation, useNavigate } from 'react-router';

function SuperAdminLayout() {
  const location = useLocation();
  const navigate = useNavigate();

  const tabs = [
    { label: 'User Management', path: '/super-admin/user-management' },
    { label: 'Team Management', path: '/super-admin/team-management' },
    { label: 'Changelog Management', path: '/super-admin/changelog-management' },
    { label: 'Feature Flags', path: '/super-admin/feature-flag-management' },
    { label: 'Job Tracker', path: '/super-admin/job-tracker' },
  ];

  const currentTab = tabs.findIndex((tab) => tab.path === location.pathname);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    navigate(tabs[newValue].path);
  };

  return (
    <>
      <Tabs
        sx={{ background: '#fff', borderBottom: 1.2, borderColor: 'divider', marginBottom: 6 }}
        value={currentTab !== -1 ? currentTab : false}
        onChange={handleTabChange}
      >
        {tabs.map((tab, index) => (
          <Tab sx={{ textTransform: 'none' }} key={index} label={tab.label} />
        ))}
      </Tabs>
      <Outlet />
    </>
  );
}

export default SuperAdminLayout;
